export const queryKeys = {
  companies: {
    all: ['companies'],
    list: ( filters ) => [...queryKeys.companies.all, 'list', filters],
    detail: ( id ) => [...queryKeys.companies.all, 'detail', id],
    questions: ( id, filters ) => [...queryKeys.companies.all, id, "questions", filters],
  },
  questions: {
    all: ['questions'],
    list: ( filters ) => [...queryKeys.questions.all, 'list', filters],
    listCounts: ( filters ) => [...queryKeys.questions.all, 'list', filters, "counts"],
    detail: ( id ) => [...queryKeys.questions.all, 'detail', id],
    batch: ( ids, filters = {} ) => [...queryKeys.questions.all, 'batch', ids, filters],
    testCases: ( id ) => [...queryKeys.questions.all, 'detail', id, "test-cases"],
    codeTemplates: ( id ) => [...queryKeys.questions.all, 'detail', id, "code-templates"],
    attemptDetails: ( id, params ) => [...queryKeys.questions.all, 'detail', id, "attempt", params],
    completedStatus: ( params ) => [...queryKeys.questions.all, "completed-status", params]
  },
  collections: {
    all: ['collections'],
    list: ( filters ) => [...queryKeys.collections.all, 'list', filters],
    detail: ( id ) => [...queryKeys.collections.all, 'detail', id],
    questions: ( id, params ) => [...queryKeys.collections.all, id, "questions", params],
  },
  topics: {
    all: ['topics'],
    list: ( filters ) => [...queryKeys.topics.all, 'list', filters],
    detail: ( id ) => [...queryKeys.topics.all, 'detail', id],
  },
  execution: {
    all: ['execution'],
    status: ( attemptId ) => [...queryKeys.execution.all, 'status', attemptId],
  },
  dashboard: {
    all: ['dashboard'],
    stats: () => [...queryKeys.dashboard.all, 'stats'],
  },
  leaderboard: {
    all: ['leaderboard'],
    users: ( search ) => [...queryKeys.leaderboard.all, 'users', search],
    userDetail: ( studentId ) => [...queryKeys.leaderboard.all, 'userDetail', studentId],
  },
  judge0: {
    allLanguages: ['languages']
  },
  notes: {
    all: ( filters ) => ['notes', 'list', filters || {}],
    detail: ( questionId ) => ['notes', 'detail', questionId],
  },
  audit: {
    institutes: ['institutes'],
    branches: ['branches'],
    departments: ( filters ) => ['departements', filters]
  },
  assessments: {
    fetchAll: filters => ["all-assessments", filters],
    fetchEnrolled: ["assessments", "enrolled"],
    fetchAssessment: assessmentId => ["all-assessments", assessmentId],
    fetchAssessmentAttempt: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "attempt", attemptId],
    fetchAssessmentLastAttempt: ( assessmentId ) => ["all-assessments", assessmentId, "attempt", "last"],
    fetchAssessmentAttemptQuestions: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "attempt", attemptId, "questions"],
    fetchAssessmentAttemptStatus: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "attempt", attemptId, "status"],
    fetchAssessmentAttemptScores: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "attempt", attemptId, "scores"],
    fetchAssessmentAttemptDetails: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "attempt", attemptId, "details"],
    fetchAssessmentAnalytics: ( assessmentId, attemptId ) => ["all-assessments", assessmentId, "analytics"],
    fetchAssessmentQuestions: assessmentId => ["all-assessments", assessmentId, "questions"],
  },
  courses: {
    fetchAll: ( filters ) => ["all-courses", filters],
    fetchById: courseId => ["all-courses", courseId],
    fetchCourseAnalytics: ( courseId, filters ) => ["all-courses", courseId, "analytics", filters],
    fetchAssessmentsByCourseId: courseId => ["all-courses", courseId, "assessments"],
    fetchSections: courseId => ["all-courses", courseId, "section"],
    fetchEnrollemntResource: ( courseId, enrollmentId, resourceId ) => ["all-courses", courseId, "learn", enrollmentId, "resource", resourceId],
    fetchEnrollemnt: ( courseId, enrollmentId ) => ["all-courses", courseId, "learn", enrollmentId],
  },
  programs: {
    fetchAll: ["all-programs"],
    fetchById: programId => ["all-programs", programId],
    fetchAssessmentsByCourseId: programId => ["all-programs", programId, "courses"],
  },
  user: {
    profile: ["user-profile"],
    fetchAssessmentsByCourseId: programId => ["all-programs", programId, "courses"],
  },
  dashboard: {
    all: ( filters ) => ['dashboard', filters],
    studentHome: ['student-dashboard'],
    stats: () => ["dashboard", 'stats'],
    upcoming: () => ["dashboard", 'upcoming'],
    recentAttempts: () => ["dashboard", 'recent-attempts'],
    performanceTrend: () => ["dashboard", 'performance-trend'],
    recommended: () => ["dashboard", 'recommended'],
    subjectPerformance: () => ["dashboard", 'subject-performance'],
    recentActivity: () => ["dashboard", 'recent-activity'],
    streak: () => ["dashboard", 'streak'],
  },
  profileEvaluation: {
    list: ["profile-eval-data"]
  },
  aiAssistant: {
    practiceAndAssessmentData: ["ai-assistant", "practice-and-assessment-data"],
    quizzesData: ["ai-assistant", "quizzes-data"],
    practiceSessionsData: ["ai-assistant", "practice-sessions-data"]
  },
  userRequests: {
    requests: () => ["requests"]
  },
  placementTracker: {
    students: {
      all: ['placement-tracker-students'],
      list: ( filters ) => [...queryKeys.placementTracker.students.all, 'list', filters],
      detail: ( id, filters ) => [...queryKeys.placementTracker.students.all, 'detail', id, filters],
      submissions: ( id ) => [...queryKeys.placementTracker.students.all, 'submissions', id],
    },
    jobs: {
      all: ['placement-tracker-jobs'],
      list: ( filters ) => [...queryKeys.placementTracker.jobs.all, 'list', filters],
      detail: ( id, filters ) => [...queryKeys.placementTracker.jobs.all, 'detail', id, ...( filters ? [filters] : [] )],
    },
    jobApplications: {
      all: ['placement-tracker-job-applications'],
      list: ( filters ) => [...queryKeys.placementTracker.jobApplications.all, 'list', filters],
    },
    companies: {
      all: ['placement-tracker-companies'],
      list: () => [...queryKeys.placementTracker.companies.all, 'list'],
      detail: ( id ) => [...queryKeys.placementTracker.companies.all, 'detail', id],
    },
    outreach: {
      all: ['placement-tracker-outreach'],
      list: ( filters ) => [...queryKeys.placementTracker.outreach.all, 'list', filters],
    },
    cycles: {
      all: ['placement-tracker-cycles'],
      list: () => [...queryKeys.placementTracker.cycles.all, 'list'],
    },
    skills: {
      all: ['placement-tracker-skills-catalog'],
      list: ( filters ) => [...queryKeys.placementTracker.skills.all, 'list', filters],
    },
    dashboard: {
      all: ['placement-tracker-dashboard'],
      stats: ( filters ) => [...queryKeys.placementTracker.dashboard.all, 'stats', filters],
      dashboardV2: ( filters ) => [...queryKeys.placementTracker.dashboard.all, 'dashboard-v2', filters],
    },
    student: {
      all: ['placement-tracker-student'],
      eligibleJobs: ( filters ) => [...queryKeys.placementTracker.student.all, 'eligible-jobs', filters],
      applications: ( filters ) => [...queryKeys.placementTracker.student.all, 'applications', filters],
      dashboard: ( filters ) => [...queryKeys.placementTracker.student.all, 'dashboard', filters],
      resumes: () => [...queryKeys.placementTracker.student.all, 'resumes'],
      skills: () => [...queryKeys.placementTracker.student.all, 'skills'],
      skillCertificates: () => [...queryKeys.placementTracker.student.all, 'skill-certificates'],
      profile: () => [...queryKeys.placementTracker.student.all, 'profile'],
      jobTimeline: ( jobId, filters ) => [...queryKeys.placementTracker.student.all, 'job-timeline', jobId, ...( filters ? [filters] : [] )],
    },
  },
}
